module.exports = __webpack_public_path__ + "img/banner.5fd83d6e.jpg";